import { FC, useState } from 'react';
import { Box, Svg, Tab, Tabs } from '@hopskipdrive/react-components';

import { OrganizerIcon } from '../../../../shared/components/Icons';
import { variables } from '../../../../shared/components/variables';
import { ErrorBoundary } from '../../../../shared/utils/errorReporting/ErrorBoundary';
import { RideOrganizer } from '../../../types/rides';
import { InfoNavContent } from '..';

import { OrganizerDetails, OrganizerInfoSkeleton } from './OrganizerDetails';

export interface OrganizerDetailsTabProps {
  organizers: RideOrganizer[];
}

export const OrganizerDetailsTab: FC<OrganizerDetailsTabProps> = ({ organizers }) => {
  const [selectedTab, setSelectedTab] = useState<string>(organizers?.length ? organizers[0].slug : '');

  return (
    <>
      <Box
        style={{
          borderTop: `1px solid ${variables.colorTokens.primary.borderDark}`,
          background: variables.colorTokens.tonal.light,
          width: '100%',
          padding: '8px 6px 8px 19px',
        }}
      >
        <Tabs
          value={selectedTab}
          sx={{
            pointerEvents: 'all',
            '& .MuiTabs-flexContainer': {
              gap: '16px',
            },
          }}
        >
          {organizers?.map((org) => (
            <Tab
              key={org.slug}
              icon={<IconAvatar isLeadOrganizer={org.leadOrganizer} />}
              label={`${org.firstName} ${org.lastName}`}
              value={org.slug}
              onClick={() => setSelectedTab(org.slug)}
              style={{
                flexDirection: 'row',
                padding: '6px 8px',
                height: '45px',
                minHeight: '33px',
                borderRadius: '24px',
                gap: '2px',
                justifyContent: 'flex-start',
                alignItems: 'center',
                border: `1px solid ${variables.colorTokens.primary.outlineBorder}`,
              }}
            />
          ))}
        </Tabs>
      </Box>
      {selectedTab && (
        <InfoNavContent>
          <ErrorBoundary FallbackComponent={OrganizerInfoSkeleton}>
            <OrganizerDetails organizerSlug={selectedTab} />
          </ErrorBoundary>
        </InfoNavContent>
      )}
    </>
  );
};

const IconAvatar = ({ isLeadOrganizer }) => (
  <Box display="flex" alignItems="center">
    <Box
      style={{
        display: 'flex',
        width: '33px',
        height: '33px',
        padding: '6.6px',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '50%',
        color: variables.colorTokens.text.contrast,
        background: variables.colorTokens.text.disabled,
      }}
    >
      <OrganizerIcon width="20px" height="20px" />
    </Box>
    {isLeadOrganizer && <Svg icon="star" />}
  </Box>
);
